import cn from 'classnames';
import { HTMLAttributes } from 'react';
import './styles.scss';

export const TextH1Medium = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  return <h1 className={cn('text-h1-medium', className)} {...props} />;
};

export const TextH2Medium = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  return <h2 className={cn('text-h2-medium', className)} {...props} />;
};

export const TextH3Regular = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  return <h3 className={cn('text-h3-regular', className)} {...props} />;
};

export const TextH3Medium = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  return <h3 className={cn('text-h3-medium', className)} {...props} />;
};

export const TextH4Medium = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  return <h4 className={cn('text-h4-medium', className)} {...props} />;
};
export const TextH4SemiBold = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  return <h4 className={cn('text-h4-semibold', className)} {...props} />;
};

export const TextH4ExtraBold = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  return <h4 className={cn('text-h4-extra-bold', className)} {...props} />;
};

export const TextH5Regular = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  return <h5 className={cn('text-h5-regular', className)} {...props} />;
};

export const TextH5Medium = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  return <h5 className={cn('text-h5-medium', className)} {...props} />;
};

export const TextH5Semibold = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  return <h5 className={cn('text-h5-semibold', className)} {...props} />;
};

export const TextH5Bold = ({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) => {
  return <h5 className={cn('text-h5-bold', className)} {...props} />;
};

export const TextBodyRegular = ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) => {
  return <p className={cn('text-body-regular', className)} {...props} />;
};

export const TextBodyMedium = ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) => {
  return <p className={cn('text-body-medium', className)} {...props} />;
};

export const TextBodySemiBold = ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) => {
  return <p className={cn('text-body-semi-bold', className)} {...props} />;
};

export const TextBodyBold = ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) => {
  return <p className={cn('text-body-bold', className)} {...props} />;
};

export const TextButtonLarge = ({ className, ...props }: HTMLAttributes<HTMLSpanElement>) => {
  return <span className={cn('text-btn-large-regular', className)} {...props} />;
};

export const TextButtonLargeMedium = ({ className, ...props }: HTMLAttributes<HTMLSpanElement>) => {
  return <span className={cn('text-btn-large-medium', className)} {...props} />;
};

export const TextButtonLargeRegular = ({
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement>) => {
  return <span className={cn('text-btn-large-regular', className)} {...props} />;
};

export const TextButtonLargeSemiBold = ({
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement>) => {
  return <span className={cn('text-btn-large-semi-bold', className)} {...props} />;
};

export const TextFootnoteDescription = ({
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement>) => {
  return <span className={cn('text-footnote-description', className)} {...props} />;
};
